// extracted by mini-css-extract-plugin
module.exports = {"aside":"sideBar_aside__Ilcap"};